// Enum các loại phụ lục tờ khai thuế
export default {
  TaSaleListOut: 0, //Bảng kê hàng hóa bán ra
  TaSaleListIn: 1, // Bảng kê hàng hóa mua vào
  TaPL01KHBS: 2, //Phụ lục tờ khai bổ sung
  TaPL011KHBS: 3, //Phụ lục giải trình khai bổ sung
  Ta432022QH15: 4, //Phụ lục theo Nghị quyết 43/2022/QH15
  TaPL1102023QH15: 5, // Phụ lục giảm thuế GTGT 110/2023/QH15
  TaPL1012023QH15: 6, // Phụ lục giảm thuế GTGT 101/2023/QH15
  TaPL1422024QH15: 7, // Phụ lục giảm thuế GTGT 142/2024/QH15
};
